// import { initSentry } from '@shared/lib/sentry'
import ReactDOM from 'react-dom/client'
import '@shared/config/i18n/i18n'

import { App } from './app'
import { ConfirmationProvider } from './providers/with-confirmation'
import { StoreProvider } from './providers/with-store'

// initSentry()
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <ConfirmationProvider>
      <StoreProvider>
        <App />
      </StoreProvider>
    </ConfirmationProvider>
  )
}
